<template>
  <div class="page" ref="homeId" @click="pageClick" :class="maxH ? 'maxh' : ''">
    <transition enter-active-class="scale-up-center">
      <div class="menu-box" v-if="hasMenu || unHome" @click="shouMenu = !shouMenu">
        <span class="menu-line"></span>
        <span class="menu-line"></span>
        <span class="menu-line"></span>
        <span class="menu-line"></span>
      </div>
    </transition>
    <div class="goout" v-if="hasMenu || unHome" v-on:click="goHome">
      <el-image fit="fill" :src="require('./assets/image/goout.png')" style="width: auto; height: 25px"></el-image>
    </div>
    <div class="close-mus" v-if="hasMenu || unHome" v-on:click="playMus">
      <el-image fit="fill" v-if="playMusic" :src="require('./assets/image/closem.png')" style="width: 40px; height: 40px"></el-image>
      <el-image fit="fill" v-else :src="require('./assets/image/openm.png')" style="width: 40px; height: 40px"></el-image>
    </div>
    <router-view />
    <el-drawer :visible.sync="shouMenu" direction="ltr" size="450px" :with-header="false" custom-class="menn-drawer" @opened="shouMenuItem = true" @closed="shouMenuItem = false">
      <transition enter-active-class="scale-up-hor-left">
        <ul v-show="shouMenuItem" class="menu-ul">
          <li class="menu-li" @click="handleMenuClick('yu')">
            <el-image fit="fill" :src="require('./assets/image/menu/yu.png')">
              <div slot="placeholder" class="custom-loading">
                <!-- 这里是你的自定义加载动画 -->
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
          </li>
          <li class="menu-li" @click="handleMenuClick('yuan')">
            <el-image fit="fill" :src="require('./assets/image/menu/yuan.png')">
              <div slot="placeholder" class="custom-loading">
                <!-- 这里是你的自定义加载动画 -->
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
          </li>
          <li class="menu-li" @click="handleMenuClick('yi')">
            <el-image fit="fill" :src="require('./assets/image/menu/yi.png')">
              <div slot="placeholder" class="custom-loading">
                <!-- 这里是你的自定义加载动画 -->
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
          </li>
          <li class="menu-li" @click="handleMenuClick('wen')">
            <el-image fit="fill" :src="require('./assets/image/menu/wen.png')">
              <div slot="placeholder" class="custom-loading">
                <!-- 这里是你的自定义加载动画 -->
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
          </li>
          <li class="menu-li" @click="handleMenuClick('cheng')">
            <el-image fit="fill" :src="require('./assets/image/menu/cheng.png')">
              <div slot="placeholder" class="custom-loading">
                <!-- 这里是你的自定义加载动画 -->
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
          </li>
          <li class="menu-li" @click="handleMenuClick('about')">
            <el-image fit="fill" :src="require('./assets/image/about-title.png')">
              <div slot="placeholder" class="custom-loading">
                <!-- 这里是你的自定义加载动画 -->
                <i class="el-icon-loading"></i>
              </div>
            </el-image>
          </li>
        </ul>
      </transition>
    </el-drawer>
    <ul class="breadcrumb" v-if="hasMenu || unHome">
      <li :class="['b-item', $route.name == 'yu' ? 'active' : '']" @click="handleMenuClick('yu')"></li>
      <li :class="['b-item', $route.name == 'yuan' ? 'active' : '']" @click="handleMenuClick('yuan')"></li>
      <li :class="['b-item', $route.name == 'yi' ? 'active' : '']" @click="handleMenuClick('yi')"></li>
      <li :class="['b-item', $route.name == 'wen' ? 'active' : '']" @click="handleMenuClick('wen')"></li>
      <li :class="['b-item', $route.name == 'cheng' ? 'active' : '']" @click="handleMenuClick('cheng')"></li>
      <li :class="['b-item', $route.name == 'about' ? 'active' : '']" @click="handleMenuClick('about')"></li>
    </ul>
    <audio ref="bjm">
      <source src="./assets/video/bj.mp3" type="audio/mp3" />
    </audio>
  </div>
</template>
<script>
import {EventBus} from './utils/eventBus.js'
export default {
  name: 'Page',
  components: {},
  data() {
    return {
      pageClicks: false,
      hasMenu: false,
      shouMenu: false,
      shouMenuItem: false,
      playMusic: false
    }
  },
  provide() {
    return {
      page: this
    }
  },
  computed: {
    maxH() {
      return this.$route.name == 'yi' || this.$route.name == 'cheng'
    },
    unHome() {
      return this.$route.name != 'home'
    }
  },
  mounted() {
    if(window.localStorage.getItem('isPlay')){
        this.playMusic = window.localStorage.getItem('isPlay')=='true'?true:false
        console.log(this.playMusic,'this.playMusic111');
      }
    EventBus.$on('isPlay',()=>{
      this.$refs.bjm.play()
    })
  },
  methods: {
    playMus() {
      this.playMusic = !this.playMusic
      console.log(this.playMusic,'this.playMusic2222');
      window.localStorage.setItem('isPlay',this.playMusic)
      // if (this.playMusic) {
      //   // this.$refs.bjm.play()
      // } else {
      //   // this.$refs.bjm.pause()
      // }
    },
    goHome() {
      if(window.localStorage.getItem('isPlay') == "true"){
        EventBus.$emit('isPlay')
      }
      window.location.href = window.location.origin
    },
    pageClick() {
      if (!this.pageClicks) {
        this.pageClicks = true
        let autoTime
        const touchEvent = function () {
          clearTimeout(autoTime)
          autoTime = setTimeout(function () {
            window.location.href = window.location.origin
          }, 1000 * 30)
        }

        this.$nextTick(() => {
          this.$refs.homeId.addEventListener('mousemove', touchEvent) //鼠标移动
          this.$refs.homeId.addEventListener('mousedown', touchEvent) //鼠标按下
          this.$refs.homeId.addEventListener('touchstart', touchEvent) //手指放到屏幕上时触发
          this.$refs.homeId.addEventListener('touchmove', touchEvent) //手指在屏幕上滑动式触发
          this.$refs.homeId.addEventListener('keydown', touchEvent) //键盘按下事件
        })
      }
    },
    handleMenuClick(item) {
      if(window.localStorage.getItem('isPlay') == "true"){
        EventBus.$emit('isPlay')
      }
      this.shouMenu = false
      this.$router.push({ name: item })
    }
  }
}
</script>

<style lang="scss">
.page {
  position: relative;
  .goout {
    cursor: pointer;
    position: absolute;
    top: 30px;
    right: 25px;
    z-index: 2;
  }
  .close-mus {
    cursor: pointer;
    position: absolute;
    bottom: 48px;
    right: 25px;
    z-index: 2;
  }
  .beian {
    font-size: 12px;
    color: #595757;
    margin-top: 12px;
  }
  .breadcrumb {
    position: absolute;
    right: 20px;
    top: 50vh;
    margin-top: -96px;
    .b-item {
      width: 12px;
      height: 12px;
      margin-bottom: 20px;
      background-color: #595757;
      cursor: pointer;
      &.active {
        background-color: #fff;
      }
    }
  }
}
.maxh {
  min-height: 1050px;
}
.menu-box {
  position: absolute;
  cursor: pointer;
  z-index: 9999;
  left: 65px;
  height: 32px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-left: 2px;
  .menu-line {
    display: block;
    width: 52px;
    height: 3.6px;
    background-color: #fff;
  }
}
.menn-drawer {
  background-color: rgba($color: #353535, $alpha: 0.9);
  padding: 84px 62px 0 58px;
  padding-right: 30px;
}
.menu-ul {
  color: #fff;
  .menu-li {
    margin-bottom: 15px;
    overflow: hidden;
    cursor: pointer;
  }
}
.scale-up-hor-left {
  -webkit-animation: scale-up-hor-left 0.4s cubic-bezier(0.39, 0.575, 0.565, 1) both;
  animation: scale-up-hor-left 0.4s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}
@keyframes scale-up-hor-left {
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
}
</style>
